import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { GlobalProvider } from './Context/GlobalContext';
import { HashRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <HashRouter>
    <GlobalProvider>
      {/* <React.StrictMode> */}
      <App />
      {/* </React.StrictMode> */}
    </GlobalProvider>
  </HashRouter>
);

reportWebVitals();
